import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProjectService } from '../services/project.service';
import { forkJoin, Observable } from 'rxjs';
import { GoalService } from '../services/goal.service';
import { StrategyService } from '../services/strategy.service';
export const goalsProjectsResolver: ResolveFn<Observable<any>> = (route, state) => {
  const projectService = inject(ProjectService);
  const goalsService = inject(GoalService);
  const strategyService = inject(StrategyService);



  const strategyId = route.queryParams['strategyId'];
  const goalId = route.queryParams['goalId'];
  return forkJoin({
    "projects": projectService.ListGoalsProjects(strategyId, goalId),
    "goal": goalsService.getGoal(strategyId, goalId),
    "strategy": strategyService.getStrategyById(strategyId)
  })


}

